import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "icon", "successIcon"]

  disconnect() {
    clearTimeout(this.resetTimeout)
  }

  async copy() {
    const text = (this.sourceTarget.value || this.sourceTarget.textContent).trim()

    await navigator.clipboard.writeText(text)
    this.showSuccess()
  }

  showSuccess() {
    this.iconTarget.classList.add("hidden")
    this.successIconTarget.classList.remove("hidden")
    clearTimeout(this.resetTimeout)
    this.resetTimeout = setTimeout(() => {
      this.successIconTarget.classList.add("hidden")
      this.iconTarget.classList.remove("hidden")
    }, 2000)
  }
}
